import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { MembershipState } from 'types/foodpassion-crm'

interface FoodpassionCrmState {
  membership: MembershipState | null
  loadingMembership: boolean
  membershipQRCode: string
}

const initialState: FoodpassionCrmState = {
  membership: null,
  loadingMembership: true,
  membershipQRCode: '',
}

export const foodpassionCrmSlice = createSlice({
  name: 'foodPassionCrm',
  initialState: initialState,
  reducers: {
    setMembership: (state, action: PayloadAction<MembershipState>) => {
      state.membership = action.payload
    },
    setLoadingMembership: (state, action: PayloadAction<boolean>) => {
      state.loadingMembership = action.payload
    },
    setMembershipQRCode: (state, action: PayloadAction<string>) => {
      state.membershipQRCode = action.payload
    },
  },
})

export const { setMembership, setLoadingMembership, setMembershipQRCode } = foodpassionCrmSlice.actions
export const foodpassionCrmSelector = (state: RootState) => state.foodpassionCrm

export default foodpassionCrmSlice.reducer
